export const AuthChallenge = {
  password: 'PASSWORD_REQUIRED',
  sso: 'SSO_REDIRECT',
} as const

export type AuthChallengeValues = (typeof AuthChallenge)[keyof typeof AuthChallenge]
